import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, forkJoin } from "rxjs";
import { CommonWebService, HttpResponse, UserHttpService, SearchObservationForm, ObservationListDetail, observationTypeList, ActionStatus, createObservation, updateObservation } from "../public-api";
@Injectable({
  providedIn: 'root'
})
export class QualityAssuranceService {

  constructor(
    private http: HttpClient,
    private userSessionService: UserHttpService,
    private commonService: CommonWebService
  ) { }

  getObservationsList(searchParams?: SearchObservationForm): Observable<HttpResponse<ObservationListDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);

    if (searchParams && searchParams.project_id) {
      formData.append("project_id", searchParams.project_id ? searchParams.project_id : "");
    }
    if (searchParams && searchParams.reported_by) {
      formData.append("reported_by", searchParams.reported_by ? searchParams.reported_by : "");
    }
    if (searchParams && searchParams.issue_type) {
      formData.append("issue_type", searchParams.issue_type ? searchParams.issue_type : "");
    }
    if (searchParams && searchParams.assigned_to) {
      formData.append("assigned_to", searchParams.assigned_to ? searchParams.assigned_to : "");
    }
    return this.http.post<HttpResponse<ObservationListDetail[]>>("quality/createObservation/observationlist", formData);
  }


  /*--Get observation detail--*/
  getObservationDetail(id: any): Observable<HttpResponse<ObservationListDetail>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("observation_id", id);
    return this.http.post<HttpResponse<ObservationListDetail>>("quality/createObservation/viewobservationdetail", formData);
  }

  /*--get all issue types--*/
  getIssueTypes(): Observable<HttpResponse<observationTypeList[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any>>("quality/issueTypeList", formData);
  }

  /*--Create Observation--*/
  addUpdateObservation(body: createObservation, type?: string): Observable<HttpResponse<observationTypeList[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);

    formData.append("project_id", body.project_id ? body.project_id : '');
    formData.append("testing_phase", body.testing_phase ? body.testing_phase : '');
    formData.append("account_used", body.account_used ? body.account_used : '');
    formData.append("platform", body.platform ? body.platform : '');
    formData.append("module_name", body.module_name ? body.module_name : '');
    formData.append("screen_name", body.screen_name ? body.screen_name : '');
    formData.append("issue_category", body.issue_category ? body.issue_category : '');
    formData.append("issue_type", body.issue_type ? body.issue_type : '');
    formData.append("reported_by", body.reported_by ? body.reported_by : '');
    formData.append("assigned_to", body.assigned_to ? body.assigned_to : '');
    formData.append("comment", body.comment ? body.comment : '');
    formData.append("status", body.status ? body.status : '');
    formData.append("createdDate", body.createdDate ? body.createdDate : '');
    formData.append("targetDate", body.targetDate ? body.targetDate : '');
    formData.append("supportingDocument", body.supportingDocument ? body.supportingDocument : '');
    formData.append("observation_id", body.observation_id ? body.observation_id : '');
    if (type != 'isAssigned') {
      return this.http.post<HttpResponse<any>>("quality/createObservation", formData);
    } else {
      return this.http.post<HttpResponse<any>>("quality/createObservation/reAssignObservation", formData);
    }
  }
  /*--Create Observation--*/

  /*--Update Observation--*/
  // updateObservation(body: updateObservation, id: string): Observable<HttpResponse<observationTypeList[]>> {
  //   let formData = new FormData();
  //   formData.append("user_id", this.userSessionService.getUserInfo.user_id);
  //   formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
  //   formData.append("token", this.userSessionService.userToken);
  //   formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
  //   formData.append("dev_comments", body.dev_comments ? body.dev_comments : "");
  //   formData.append("status", body.status ? body.status : "");
  //   formData.append("observation_id", id ? id : '');
  //   return this.http.post<HttpResponse<any>>("quality/createObservation/observationUpdatebyDev", formData);
  // }
  /*--get dropdowns data--*/
  fetchDropdownsData(): Observable<any[]> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    const testingPhases$ = this.http.post<HttpResponse<any[]>>("quality/testingPhaseList", formData);
    const issueCategories$ = this.http.post<HttpResponse<any[]>>("quality/issueCategoryList", formData);
    const issueTypes$ = this.http.post<HttpResponse<any[]>>("quality/issueTypeList", formData);
    const platforms$ = this.http.post<HttpResponse<any[]>>("quality/platformList", formData);
    const qaStatus$ = this.http.post<HttpResponse<any[]>>("quality/QaStatusList", formData);
    return forkJoin([testingPhases$, issueCategories$, issueTypes$, platforms$, qaStatus$]);
  }
  /*--get all employees--*/
  getEmployees(): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any[]>>("employees/employeeListing", formData);
  }

  /*--Accept issue--*/
  acceptObservation(id: any): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append('observation_id', id);
    return this.http.post<HttpResponse<any[]>>("quality/createObservation/acceptobservation", formData);
  }

  /*--Reject Observation--*/
  rejectObservation(id: any): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append('observation_id', id);
    return this.http.post<HttpResponse<any[]>>("quality/createObservation/declineobservation", formData);
  }

  /*--Export CSV--*/
  exportObservationCsv(): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any[]>>("quality/ExportObservationCSV", formData);
  }

  /*--import CSV--*/
  importObservationCsv(file: File): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any[]>>("quality/ImportObservationCSV", formData);
  }

  /*--Qa Report--*/
  projectQaReportDashboardData(projectId: string): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("project_id", projectId);
    return this.http.post<HttpResponse<any[]>>("quality/Qa_ReportDashboard", formData);
  }

  /*--Qa TestPhase Detail--*/
  projectQaTestingPhaseDetail(project_id: string, testingPhase_id: string): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("project_id", project_id);
    formData.append("testingphase_id", testingPhase_id);
    return this.http.post<HttpResponse<any[]>>("quality/Qa_ViewReport", formData);
  }

  /*--Add QA Phase--*/
  addNewQaPhase(body: { testingPhase: any }): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("testingPhase", body.testingPhase ? body.testingPhase : '');
    return this.http.post<HttpResponse<any>>("quality/testingPhaseList/add", formData);
  }

  /*--Delete QA Phase--*/
  deleteQaPhase(testingPhaseId: any): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("testingPhaseId", testingPhaseId);
    return this.http.post<HttpResponse<any[]>>("quality/testingPhaseList/delete", formData);
  }

  /*--get table data for QA phases--*/
  fetchQaPhasesdata(): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any[]>>("quality/testingPhaseList", formData);
  }

  /*--Add QA Platform--*/
  addNewQaPlatform(body: { platform_name: any }): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("platform_name", body.platform_name ? body.platform_name : '');
    return this.http.post<HttpResponse<any>>("quality/platformList/add", formData);
  }
  /*--Delete QA Platform--*/
  deleteQaPlatform(platformId: any): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("platformId", platformId);
    return this.http.post<HttpResponse<any[]>>("quality/platformList/delete", formData);
  }
  /*--get table data for QA phases--*/
  fetchQaPlatformdata(): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any[]>>("quality/platformList", formData);
  }
  /*--Issue Category--*/
  /*--Add QA Issue Category--*/
  addNewQaIssueCategory(body: { issueCategoryName: any }): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("issueCategoryName", body.issueCategoryName ? body.issueCategoryName : '');
    return this.http.post<HttpResponse<any>>("quality/issueCategoryList/add", formData);
  }
  /*--Delete QA Issue category--*/
  deleteQaIssueCategory(qa_IssueCategory_id: any): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("issueCategoryId", qa_IssueCategory_id);
    return this.http.post<HttpResponse<any[]>>("quality/issueCategoryList/delete", formData);
  }
  /*--get table data for QA issue Category--*/
  fetchIssueCategories(): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any[]>>("quality/issueCategoryList", formData);
  }
  /*--Issue Type--*/
  /*--Add Issue Type--*/
  addNewIssueType(body: { issueTypeName: any }): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("issueTypeName", body.issueTypeName ? body.issueTypeName : '');
    return this.http.post<HttpResponse<any[]>>("quality/issueTypeList/add", formData);
  }
  /*--Delete Issue Type--*/
  deleteIssueType(qa_IssueType_id: any): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("issueTypeid", qa_IssueType_id);
    return this.http.post<HttpResponse<any[]>>("quality/issueTypeList/delete", formData);
  }
  /*--get table data for Issue Type--*/
  fetchIssueTypes(): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("customer_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<any[]>>("quality/issueTypeList", formData);
  }
}